import { useState, useEffect } from 'react';
import { Link } from "react-scroll";
import Logo from "../images/logo.png";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { id: "company", label: "OUR COMPANY" },
    { id: "vision", label: "OUR VISION" },
    { id: "products", label: "OUR PRODUCTS" },
    { id: "marketresearch", label: "MARKET RESEARCH" },
    { id: "strengths", label: "KEY STRENGTHS" },
    { id: "contact", label: "CONTACT US" }
  ];

  return (
    <nav className={`fixed top-0 w-full bg-gradient-to-r from-teal-900 to-green-600 shadow-md z-50 transition-all duration-300 ${
      scrolled ? 'py-2' : 'py-3 md:py-4'
    }`}>
      <div className="container mx-auto px-4 sm:px-6">
        <div className="flex justify-between items-center">
          {/* Logo Section */}
          <Link 
            to="hero" 
            smooth={true} 
            duration={500} 
            className="flex items-center space-x-2 cursor-pointer"
          >
            <img 
              src={Logo} 
              alt="Logo" 
              className={`transition-all duration-300 ${
                scrolled ? 'w-10 h-6 md:w-12 md:h-8' : 'w-12 h-8 md:w-15 md:h-10'
              } filter invert brightness-0 contrast-100`} 
            />
            <h1 className={`text-lg md:text-xl font-bold text-white tracking-wide uppercase transition-all duration-300 font-serif ${
              scrolled ? 'text-base' : ''
            }`}>
              LET'S TRADE AFRICA
            </h1>
          </Link>

          {/* Desktop Navigation */}
          <ul className="hidden lg:flex space-x-4 xl:space-x-6">
            {navItems.map((item) => (
              <li key={item.id}>
                <Link
                  to={item.id}
                  smooth={true}
                  duration={500}
                  spy={true}
                  offset={-80}
                  activeClass="font-bold border-b-2 border-green-300"
                  className="cursor-pointer text-white text-sm xl:text-base font-light hover:text-white transition-colors px-2 pb-1"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>

          {/* Tablet Navigation (fewer items) */}
          <ul className="hidden md:flex lg:hidden space-x-4">
            {navItems.slice(0, 4).map((item) => (
              <li key={item.id}>
                <Link
                  to={item.id}
                  smooth={true}
                  duration={500}
                  spy={true}
                  offset={-80}
                  activeClass="font-bold border-b-2 border-green-300"
                  className="cursor-pointer text-white text-xs font-medium hover:text-white transition-colors px-1 pb-1"
                >
                  {item.label.split(' ')[1]}
                </Link>
              </li>
            ))}
          </ul>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden text-white focus:outline-none p-1"
            onClick={() => setIsOpen(!isOpen)}
            aria-label="Toggle menu"
          >
            <svg 
              className="w-6 h-6" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24" 
              xmlns="http://www.w3.org/2000/svg"
            >
              {isOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        <div className={`lg:hidden bg-gradient-to-b from-teal-800 to-green-700 rounded-lg mt-2 ${
          isOpen ? 'block animate-fadeIn' : 'hidden'
        }`}>
          <ul className="flex flex-col divide-y divide-green-500/30">
            {navItems.map((item) => (
              <li key={item.id}>
                <Link
                  to={item.id}
                  smooth={true}
                  duration={500}
                  spy={true}
                  offset={-80}
                  activeClass="font-bold bg-green-900/30 text-green-300"
                  className="cursor-pointer block text-white font-medium hover:text-green-300 transition-colors py-3 px-4"
                  onClick={() => setIsOpen(false)}
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
